const parserHTML = require('js/lib/parserHTML');
const parserText = require('js/lib/parserText');

const FIELDS = [
  'body',
  'postSnippet',
  'postBodySnippet',
  'startSnippet',
  'snippet',
  'title',
  'aboutMe',
].map(field => ({
  original: field,
  enriched: 'enriched' + field[0].toUpperCase() + field.slice(1),
  formatted: 'formatted' + field[0].toUpperCase() + field.slice(1),
}));

module.exports = function formatModel({ model, users = [], extra, options }) {
  // @FIXME:
  if (model.title && model.title.displayName) {
    model.title = model.title.displayName;
  }

  // @TODO: discuss with the backend the utility of this new field
  if (model.snippets) {
    model.snippet = model.snippets.join(' ').slice(0, 141).concat('...');
  }

  const userMap = {};
  users.forEach(user => userMap[user.id || user.userId] = user);

  const disabledReplacementTypes = (!!options && options.disabledReplacementTypes) || {};
  const newFields = {};
  FIELDS
    .forEach(field => {
      newFields[field.enriched] = parserText.parseString(model[field.original] || '', { userMap }, disabledReplacementTypes);
      newFields[field.formatted] = parserHTML.getElement(newFields[field.enriched], false, field.original !== 'body');
    });
  if (newFields.enrichedBody.length > 0) {
    let limit = 140;
    newFields.enrichedSnippet = JSON.parse(JSON.stringify(newFields.enrichedBody))
      .filter(item => {
        if (limit < 0) {
          return false;
        }
        switch (item.type) {
          case 'mention':
            if (!item.username) item.username = '';
            limit -= item.username.length;
            return true;
          case 'link':
            const oldLimit = limit;
            limit -= item.text.length;
            return oldLimit < 80 || limit >= -20;
          case 'text':
            const newLimit = limit - item.text.length;
            item.text = item.text.slice(0, limit);
            limit = newLimit;
            return true;
          case 'return':
            return true;
          case 'smiley':
            limit -= item.originalText.length;
            return true;
        }
      });
    if (limit < 0) {
      newFields.enrichedSnippet.push({ type: 'text', text: '...', style: {}});
    }
    newFields.enrichedSnippet = newFields.enrichedSnippet;
    newFields.formattedSnippet = parserHTML.getElement(newFields.enrichedSnippet, false, true);
  }

  return Object.assign({}, model, newFields, extra);
};



// WEBPACK FOOTER //
// ./app/assets/js/lib/formatModel.js